import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormatPhoneNumbersPipe } from 'src/app/pipes/format-phone-numbers/format-phone-numbers.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { PhoneNumberOption } from '../models/phone-number-option';
import { phoneNumberOptionSelectors } from '../state/phone-number-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: PhoneNumberSelectComponent,
        },
    ],
    selector: 'ndt-phone-number-select',
    templateUrl: './phone-number-select.component.html',
    standalone: false
})
export class PhoneNumberSelectComponent extends LcsSingleSelectBase<PhoneNumberOption> implements OnInit {
   @Input() onlyAllowOutboundCallsNumbers?: boolean;

   @Input() includeFax = false;

   @Input() phoneNumbersToExclude: PhoneNumberOption[] = [];

   phoneNumbers: Observable<PhoneNumberOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.phoneNumbers = this.store.pipe(
         select(phoneNumberOptionSelectors.selectFilteredItems),
         this.itemsLoaded(),
         map((results) => {
            return results.filter((number) => {
               return !this.phoneNumbersToExclude.find((x) => {
                  return x.phoneNumberId === number.phoneNumberId;
               });
            });
         })
      );
   }

   displayWith(item: PhoneNumberOption | null): string | null {
      if (!item) {
         return null;
      }
      const formatPhonePipe = new FormatPhoneNumbersPipe();
      const formattedPhone = formatPhonePipe.transform(item.phoneNumber);
      return formattedPhone ? (item.displayName ? `${formattedPhone} - ${item.displayName}` : formattedPhone) : null;
   }

   trackBy(item: PhoneNumberOption | null) {
      return item ? item.phoneNumberId : null;
   }
}
